module.exports = __webpack_public_path__ + "7bde4727105b91b3beeadfd20e2b52c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091117_0077_w.jpg
// module id = 359
// module chunks = 0